import { api, podatki, type Shema } from '../api/odjemalec';

/** Doda en dokument k vozilu (napaka ob polju {@code datoteka}). */
export async function shraniEnega(voziloId: number, f: File): Promise<Shema['DokumentVozila']> {
  const telo = new FormData();
  telo.append('datoteka', f);
  return podatki(
    api.POST('/api/vozila/{id}/dokumenti', {
      params: { path: { id: voziloId } },
      body: telo as unknown as { datoteka: string },
    }),
  );
}

/** Shrani datoteke k vozilu (po branju dokumentov ob dodajanju); vrne imena tistih, ki jih ni bilo mogoče shraniti. */
export async function shraniDokumente(voziloId: number, datoteke: File[]): Promise<string[]> {
  const neshranjeni: string[] = [];
  for (const f of datoteke) {
    try {
      await shraniEnega(voziloId, f);
    } catch {
      neshranjeni.push(f.name);
    }
  }
  return neshranjeni;
}
